import { render } from "./routeDetail.vue?vue&type=template&id=27c7f0d2&scoped=true"
import script from "./routeDetail.vue?vue&type=script&lang=js"
export * from "./routeDetail.vue?vue&type=script&lang=js"

import "./routeDetail.vue?vue&type=style&index=0&id=27c7f0d2&lang=less&scoped=scoped"

import exportComponent from "/data/spug/spug_api/repos/34_1470_20220520214630/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c7f0d2"]])

export default __exports__